// import { msntConsent } from '../msnt-consent';

let loadingPromise;

const initFroomle = (params) => {
  if (loadingPromise) return loadingPromise;
  console.log('froomle initialized');

  if (!window.jsVars.froomle) return Promise.resolve();

  // both imports must stay inside initFroomle and below the jsVars guard:
  // a static import of the config pulls @msnt-shared/packages/froomle
  // (52 KB) into the initial bundle of every page via layout.js
  loadingPromise = Promise.all([
    import(/* webpackChunkName: "froomle" */ '@msnt-shared/packages/froomle'),
    import(/* webpackChunkName: "froomle" */ './froomle-default-config'),
  ])
    .then(([module, { config }]) => {
      module.setDefaults(config);

      const froomleApi = module.init(params);

      handleFroomleLoaded(froomleApi);

      return froomleApi;
    })
    // eslint-disable-next-line no-console
    .catch((err) => console.error(`[MSNT] Failed to load "Froomle" =>`, err));

  return loadingPromise;
};

const handleFroomleLoaded = async (froomleApiPromise) => {
  const froomleApi = await froomleApiPromise;

  if (!froomleApi) return;

  //to fix
  // msntConsent.addEventListener((state) => {
  //   froomleApi.setConsentState(state?.consents.analytics ?? false);
  // });
  froomleApi.setConsentState(true);
};

const getFroomleApi = () => {
  if (loadingPromise) return loadingPromise;

  return new Promise((resolve) => {
    window.addEventListener(
      'msnt-froomle-api-ready',
      () => {
        resolve(loadingPromise);
      },
      {
        once: true,
      },
    );
  });
};

export { initFroomle, getFroomleApi };
